import { memo } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import { isNilOrEmptyString } from 'ramda-extension';

import { getStringOrOneOf } from 'features/views/taskDetail/utils';
import { getClientName } from 'utils/client';
import { equalOrThreeDashes, fromIsoDate } from 'utils/index';
import { joinString } from 'utils/string';

export const Row = ({ client, onSelect, index }) => {
	const clientName = getClientName(client);
	const finalAddress = client?.contactAddress || client?.permanentAddress;

	const fullStreet = getStringOrOneOf(finalAddress?.street, finalAddress?.streetNo);
	const wholeAddress = joinString(', ', [fullStreet, finalAddress?.municipality, finalAddress?.zipCode]);

	return (
		<>
			<TableCell>
				<Link
					underline="none"
					data-client-id={index}
					id="clientSelectRow"
					onClick={onSelect}
					sx={{ cursor: 'pointer' }}
				>
					{clientName}
				</Link>
			</TableCell>
			<TableCell>{fromIsoDate(client.birthDate || '')}</TableCell>
			<TableCell>{equalOrThreeDashes(client.businessIn)}</TableCell>
			<TableCell>{!isNilOrEmptyString(wholeAddress) ? wholeAddress : '---/---'}</TableCell>
		</>
	);
};

Row.propTypes = {
	client: PropTypes.object,
	index: PropTypes.number,
	onSelect: PropTypes.func,
};

export default memo(Row);
